var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.816406,
    y: 0.342773,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#1565D8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9041 30.8775L33.4275 36.706C34.0263 37.3379 35.1109 37.4281 36.3191 36.8327C39.3941 35.5579 40.4172 35.2471 41.0012 35.8634L47.3504 42.5633C48.101 43.3553 47.9007 44.6745 47.0614 45.5601C42.7034 50.1588 35.6201 50.1588 31.2622 45.5601L19.4015 33.0443C15.0654 28.4687 15.0654 21.0662 19.4015 16.4905C20.2585 15.5862 21.5746 15.3637 22.3534 16.1855L28.7026 22.8855C29.2529 23.4662 28.9578 24.5478 27.7563 27.7706C27.1978 29.0285 27.2873 30.2266 27.9041 30.8775Z",
    fill: "#DFAD17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.f637d6ea6cc6d20226162780dca4d079.svg";
export { ForwardRef as ReactComponent };